import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLoupeSearch48 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M21.2512 39.5214C31.3313 39.5214 39.5214 31.3504 39.5214 21.2512C39.5214 11.1519 31.3504 3 21.2512 3C11.1519 3 3 11.171 3 21.2512C3 31.3313 11.171 39.5214 21.2703 39.5214H21.2512Z" stroke="currentColor" strokeWidth={1.6} strokeLinecap="square" /><path d="M45 44.9995L34.1753 34.1748" stroke="currentColor" strokeWidth={1.6} strokeLinecap="square" /></svg>;
const ForwardRef = forwardRef(SvgLoupeSearch48);
export default ForwardRef;